/* unplugin-vue-components disabled */import { render } from "./userInfo.vue?vue&type=template&id=00c19eba"
import script from "./userInfo.vue?vue&type=script&lang=js"
export * from "./userInfo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/haonanzeng/Desktop/PigGTEx-Portal/piggtex-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__